function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2a2 2 0 012-2h32a2 2 0 110 4H2a2 2 0 01-2-2z",
  fill: "#7D7D7D"
});

function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 4,
    viewBox: "0 0 36 4",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDM2IDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAyQzAgMC44OTU0MzEgMC44OTU0MzEgMCAyIDBIMzRDMzUuMTA0NiAwIDM2IDAuODk1NDMxIDM2IDJDMzYgMy4xMDQ1NyAzNS4xMDQ2IDQgMzQgNEgyQzAuODk1NDMyIDQgMCAzLjEwNDU3IDAgMloiIGZpbGw9IiM3RDdEN0QiLz4KPC9zdmc+Cg==";
export { SvgDrag as ReactComponent };